import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getMonitoringPlan({ commit }, params) {
    const apiResult = await apiService.get(route('member.monitoring-plan.list'), params)
    if (apiResult) {
      return apiResult
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
